document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.product-specs-comparison');
  if (!sections.length) return;

  sections.forEach(function (el) {
    var headerSwiper = null;
    var contentSwiper = null;

    /* ===== Sync row heights + draw full-width separator lines ===== */
    function syncRowHeights() {
      var contentRow = el.querySelector('.specs-content-row');
      var fixRows = el.querySelectorAll('.specs-fix-body .specs-fix-row');
      var slides = el.querySelectorAll('.specs-content-swiper .swiper-slide');

      /* Remove old separators */
      var oldSeps = contentRow.querySelectorAll('.specs-row-separator');
      for (var o = 0; o < oldSeps.length; o++) {
        oldSeps[o].parentNode.removeChild(oldSeps[o]);
      }

      /* Track cumulative top offset for each row's bottom edge */
      var currentTop = 0;

      for (var i = 0; i < fixRows.length; i++) {
        /* Reset inline height before measuring */
        fixRows[i].style.minHeight = '';
        fixRows[i].style.height = '';
        for (var s = 0; s < slides.length; s++) {
          var resetItems = slides[s].querySelectorAll('.specs-content-row-item');
          if (resetItems[i]) {
            resetItems[i].style.minHeight = '';
            resetItems[i].style.height = '';
          }
        }

        var maxH = fixRows[i].getBoundingClientRect().height;

        for (var s = 0; s < slides.length; s++) {
          var items = slides[s].querySelectorAll('.specs-content-row-item');
          if (items[i]) {
            maxH = Math.max(maxH, items[i].getBoundingClientRect().height);
          }
        }

        fixRows[i].style.minHeight = maxH + 'px';
        for (var s2 = 0; s2 < slides.length; s2++) {
          var items2 = slides[s2].querySelectorAll('.specs-content-row-item');
          if (items2[i]) {
            items2[i].style.minHeight = maxH + 'px';
          }
        }

        /* Draw full-width separator at the bottom of this row */
        var sep = document.createElement('div');
        sep.className = 'specs-row-separator';
        sep.style.top = currentTop + maxH + 'px';
        contentRow.appendChild(sep);

        currentTop += maxH;
      }
    }

    function init() {
      if (headerSwiper) headerSwiper.destroy(true, true);
      if (contentSwiper) contentSwiper.destroy(true, true);

      var mobile = window.innerWidth < 851;
      var spv = mobile ? 3 : 'auto';

      var cfg = {
        direction: 'horizontal',
        slidesPerView: spv,
        spaceBetween: 0,
        allowTouchMove: false,
        freeMode: false,
        breakpoints: {
          390:   { slidesPerView: 3 },
          768:   { slidesPerView: 3 },
          851:   { slidesPerView: 'auto' }
        }
      };

      headerSwiper = new Swiper(
        el.querySelector('.specs-products-header-swiper'),
        Object.assign({}, cfg, { watchSlidesProgress: true })
      );

      contentSwiper = new Swiper(
        el.querySelector('.specs-content-swiper'),
        Object.assign({}, cfg, { controller: { control: headerSwiper } })
      );

      headerSwiper.controller.control = contentSwiper;

      /* Sync heights after Swiper init */
      syncRowHeights();
    }

    init();

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        init();
      }, 250);
    });
  });
});
